import React, { useState, useEffect, useRef } from 'react';
import { Box, TextInput, Button, Layer, FormField } from 'grommet';
import './FlightEditForm.css';
import { useStore } from '../../../../../../Hooks/useStore';
import { observer } from 'mobx-react';
import closeSidebar from "../../../../../../assets/close_small.svg";
import { Select } from 'grommet';
// import { toJS } from 'mobx';
import createFlightService from '../Users/CreateFlight/create-flight.service';
import { FlightService } from '../../../../../../services/flights/flight.service';



const FlightEditForm = observer(({ flight, onClose }) => {
  const { rootStore } = useStore();
  const [editedFlight, setEditedFlight] = useState({ ...flight, msn: '' });
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedFlight({ ...editedFlight, [name]: value });
  };

  const handleSubmit = async (e) => {
    
    e.preventDefault();
  
    /*
      const fleetType = {
        id: rootStore.flightsStore.getFleetType?.value || selectedFleetType.value,  // Fallback to empty string if no value is available
        airCraftType: rootStore.flightsStore.getFleetType?.label || selectedFleetType.label || rootStore.flightsStore.getFleetType // Fallback to empty string if no label is available
    };
    
    const wifiProvider = {
        id: rootStore.flightsStore.getWifiProvider?.value || selectedWifiType.value,  // Fallback to empty string if no value is available
        wifiProvider: rootStore.flightsStore.getWifiProvider?.label || selectedWifiType.label || rootStore.flightsStore.getWifiProvider  // Fallback to empty string if no label is available
    };
    */


    try {
        await createFlightService.updateFlight(
            rootStore.flightsStore.getId,
            rootStore.flightsStore.getMsn,
            rootStore.flightsStore.getTailNumber,
            selectedFleetType,
            selectedWifiType,
            rootStore.flightsStore.getOrg
        );

        rootStore.notificationToastStore.showNotification("Flight updated successfully", false, 3000);
        rootStore.flightsStore.handleupdate();
        onClose();
    } catch (error) {
        console.error('Error handling flight:', error);
        rootStore.notificationToastStore.showNotification("Failed to update flight. Please try again later.", true, 'error-message');
    }
};



  // const handleReset = () => {
  //   setEditedFlight({ ...flight });
  //   rootStore.flightsStore.handleMsn("");
  //   rootStore.flightsStore.handleFleetType("");
  //   rootStore.flightsStore.handleWifiProvider("");
  // };
  
  

  const handleReset = () => {
    try {
      FlightService.getFlight(rootStore.flightsStore.getflightID).then((flightResponse) => {
        rootStore.flightsStore.handleId(flightResponse.id);
        rootStore.flightsStore.handleMsn(flightResponse.msn);
        rootStore.flightsStore.handleTailNumber(flightResponse.tailNumber);
        rootStore.flightsStore.handleFleetType(flightResponse.fleetType);
        setSelectedFleetType(flightResponse.fleetType);
        rootStore.flightsStore.handleWifiProvider(flightResponse.wifiProvider);
        setSelectedWifiType(flightResponse.wifiProvider);
        rootStore.flightsStore.handleOrg(flightResponse.organization.id);
        // rootStore.flightsStore.handleSpecificFlights(flightResponse);

      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    (async () => {
      let organizations = await createFlightService.getOrganizations();
      rootStore.flightsStore.handleEditFlightOrgList(organizations);
    })();
  }, []);

  // ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||
  const flightOptions = rootStore.flightsStore.getFlightList.map(flight => ({
    value: flight.id,
    label: flight.airCraftType
  }));

  const [showOptions, setShowOptions] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [selectedFleetType, setSelectedFleetType] = useState(rootStore.flightsStore.getFleetType);
  const [filteredOptions, setFilteredOptions] = useState(flightOptions); // Initialize with all options
 


  const handleTextInputChange = (event) => {
    const value = event.target.value;
    setFilterText(value);
    setSelectedFleetType(value); // Update selectedFleetType with input text
    setShowOptions(true); // Show options as user types

    // Filter options based on input value
    // const newFilteredOptions = flightOptions.filter(option =>
    //   option.label.toLowerCase().includes(value.toLowerCase())
    // );
    const newFilteredOptions = flightOptions.filter(option => {
      if (!option.label || value === null) return false;
      return option.label.toLowerCase().includes(value.toLowerCase());
    });
    
    setFilteredOptions(newFilteredOptions); // Update filtered options
    const flightList = rootStore.flightsStore.getFlightList
    const selectedFlight = flightList.find((flight) => flight.airCraftType === value);

    // rootStore.flightsStore.handleFleetType({label:event.target.value,value:null});
    if (selectedFlight) {
      rootStore.flightsStore.handleFleetType({label:selectedFlight.airCraftType,value:selectedFlight.id});
    } else {
      rootStore.flightsStore.handleFleetType({ label: value, value: null })
    }
  };

  const handleOptionClick = (option) => {
    setSelectedFleetType(option.label); // Set selected fleet type
    setFilterText(option.label); // Set filter text to the selected option
    setShowOptions(false); // Hide the options
    rootStore.flightsStore.handleFleetType(option); // Update the store
  };


  const wifiProviderOptions = rootStore.flightsStore.getWifiProviderList.map(wifi => ({
    value:wifi.id,
    label: wifi.wifiProvider
  }))

  const [showWifiOptions, setShowWifiOptions] = useState(false);
  const [wifiFilterText, setWifiFilterText] = useState('');
  const [selectedWifiType, setSelectedWifiType] = useState(rootStore.flightsStore.getWifiProvider);
  const [filteredWifiOptions, setFilteredWifiOptions] = useState(wifiProviderOptions);

  const handleWifiTextInputChange = (event) => {
    const value = event.target.value;
    setWifiFilterText(value);
    setSelectedWifiType(value); // Update selectedFleetType with input text
    setShowWifiOptions(true); // Show options as user types
    // Filter options based on input value

    // const newFilteredOptions = wifiProviderOptions.filter(option =>
    //   option.label.toLowerCase().includes(value.toLowerCase())
    // );
    const newFilteredOptions = wifiProviderOptions.filter(option => {
      if (!option.label || value === null) return false;
      return option.label.toLowerCase().includes(value.toLowerCase());
    });
       
    setFilteredWifiOptions(newFilteredOptions); // Update filtered options
    // rootStore.flightsStore.handleWifiProvider({label:event.target.value, value:null});
    const wifiList = rootStore.flightsStore.getWifiProviderList
    const selectedWifi = wifiList.find((wifi) => wifi.wifiProvider === value);
    if (selectedWifi) {
      rootStore.flightsStore.handleWifiProvider({label:selectedWifi.wifiProvider,value:selectedWifi.id});
    } else {
      rootStore.flightsStore.handleWifiProvider({ label: value, value: null })
    }
  };

  const handleWifiOptionClick = (option) => {
    setSelectedWifiType(option.label); // Set selected fleet type
    setWifiFilterText(option.label); // Set filter text to the selected option
    setShowWifiOptions(false); // Hide the options
    rootStore.flightsStore.handleWifiProvider(option); // Update the store
  };

  // ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||

  const handleSelectOrg = (selectedOrgId) => {
    rootStore.flightsStore.getSpecificFlights.organization = {
      ...rootStore.flightsStore.getSpecificFlights.organization,
      id: selectedOrgId
    };
  };
  const handleMsnChange = (e) => {
    const value = e.target.value;
      rootStore.flightsStore.handleMsn(value);
  };
  let userInfo;
  useEffect(() => {
    (
      async () => {
        userInfo = localStorage.getItem("userinfo");
        if (userInfo) {
          let roleLabel = JSON.parse(userInfo).roleLabel;
          rootStore.adminStore.handleRoleLabel(roleLabel);
        }
      }
    )();
  }, [userInfo]);


  
  // Handle outside click
  const aircraftRef = useRef(null);
    useEffect(() => {
    const handleAircraftClickOutside = (event) => {
      if (aircraftRef.current && !aircraftRef.current.contains(event.target)) {
        setShowOptions(false); // Close the dropdown
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleAircraftClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleAircraftClickOutside);
    };
  }, []);

  // Add this in your component
  const wifiDropdownRef = useRef(null);

  useEffect(() => {
    const handleWifiClickOutside = (event) => {
      if (wifiDropdownRef.current && !wifiDropdownRef.current.contains(event.target)) {
        setShowWifiOptions(false); // Close the dropdown
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleWifiClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleWifiClickOutside);
    };
  }, []);
  // End Handle outside click

  return (

    <Layer
      className='outer'
      full="vertical"
      position="right"
      onClickOutside={() => { rootStore.emsStore.handleAssignModal(false); rootStore.emsStore.handleSelectEmsId(""); rootStore.emsStore.handleEmsListSearch(""); onClose(); }}
      onEsc={() => { rootStore.emsStore.handleAssignModal(false); rootStore.emsStore.handleSelectEmsId(""); rootStore.emsStore.handleEmsListSearch(""); onClose();}}
      style={{ borderRadius: "12px 0 0 12px", zIndex: 1000 }}
    >
      <div className="flight-header">
        <div className="headerr">Edit Flights</div>
        <Button className='close-btn' onClick={onClose}><img src={closeSidebar} style={{ width: 20, height: 20 }} />Close</Button>

      </div>


      <form onSubmit={handleSubmit} style={{ padding: "0 20px", overflow: 'auto' }}>
        <div className='lay'>
          {/* <div className='mt-16'>
          <label className='label'>MSN</label>
          <TextInput
          className='input-style'
            name="msn"
            value={rootStore.flightsStore.getMsn}
            onChange={(e)=>rootStore.flightsStore.handleMsn(e.target.value)}
          />
        </div> */}
        <FormField name="tailNumber" className='mt-16 label' htmlFor="textinput-id" required>
            <label className='label'>TailNumber</label>

            <TextInput
              style={{ opacity: 0.5 }}
              className='input-style'
              placeholder='Enter here'
              id="textinput-id"
              name="tailNumber"
              value={rootStore.flightsStore.getTailNumber}
            // onChange={(e)=>rootStore.flightsStore.handleTailNumber(e.target.value)}
            />

          </FormField>
          <div className='mt-16'>
            <label className='label'>MSN</label>
            <TextInput
              className='input-style'
              name="msn"
              maxLength={100}
              value={rootStore.flightsStore.getMsn}
              onChange={handleMsnChange}
            />
          </div>


          <div className='mt-16'>
            <label className='label'>Fleet Type</label>
            <TextInput
              style={{ opacity: 0.5 }}
              className='input-style'
              name="fleettype"
              maxLength={100}
              value={selectedFleetType} // Controlled value based on state
              //onChange={handleTextInputChange} // Update the input value and filtered options
              //onFocus={() => setShowOptions(true)} // Show options on focus
              required
            />
            {showOptions && filteredOptions.length > 0 && (
              {/*
                <ul style={{ listStyleType: 'none', margin: '0px',paddingLeft:'5px',marginLeft:"2px" }} ref={aircraftRef}>
                {filteredOptions.map((item) => (
                  <li
                    style={{ textDecoration: 'none', paddingLeft: '5px',paddingTop:'10px',paddingBottom:'10px',margin:"0px", cursor: 'pointer',boxShadow: "0 0px 1px rgba(0, 0, 0, 0.1)"}}
                    key={item.value} // Use the value as the key
                    onClick={() => handleOptionClick(item)} // Handle option click
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
              */}
            )}
          </div>

          <div className='mt-16'>
            <label className='label'>Wi-Fi Provider</label>
            {/* <TextInput
              className='input-style'
              name="wifiprovider"
              value={rootStore.flightsStore.getWifiProvider}
              onChange={(e) => rootStore.flightsStore.handleWifiProvider(e.target.value)}
            /> */}
            <TextInput
              style={{ opacity: 0.5 }}
              className='input-style'
              name="wifiprovider"
              maxLength={100}
              value={selectedWifiType} // Controlled value based on state
              //onChange={handleWifiTextInputChange} // Update the input value and filtered options
              //onFocus={() => setShowWifiOptions(true)} // Show options on focus
            />
            {showWifiOptions && filteredWifiOptions.length > 0 && (
              {/*
              <ul style={{ listStyleType: 'none', margin: '0px',paddingLeft:'5px',marginLeft:"2px" }} ref={wifiDropdownRef}>
                {filteredWifiOptions.map((item) => (
                  <li
                  style={{ textDecoration: 'none', paddingLeft: '5px',paddingTop:'10px',paddingBottom:'10px',margin:"0px", cursor: 'pointer',boxShadow: "0 0px 1px rgba(0, 0, 0, 0.1)"}}
                    key={item.value} // Use the value as the key
                    onClick={() => handleWifiOptionClick(item)} // Handle option click
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
              */}
            )}
          </div>


          <div className="organization-select">
            <label className='label'>Organization</label>
            {rootStore.flightsStore.getEditFlightOrgList.length > 0 ? (
              <div className="create-user-org-outer">

                <Select
                  style={{ opacity: 0.5 }}
                  name="organization"
                  labelKey={"label"}
                  valueKey={{ key: "value", reduce: true }}
                  options={rootStore.flightsStore.getEditFlightOrgList.map((org) => {
                    return {
                      label: org.name,
                      value: org.id,
                    };
                  })}
                  value={rootStore.flightsStore.getOrg}
                  defaultValue={""}
                  onChange={(event) => {
                    if (rootStore.adminStore.getRoleName.toLowerCase() != "superadmin" && rootStore.adminStore.getRoleName.toLowerCase() != "admin") {
                      rootStore.flightsStore.handleOrg(event.option.value);
                    }
                  }}
                />

              </div>
            ) : null
            }
          </div>

        </div>


        <div className='btn-outer'>
          <Button className='reset' type="Reset" label="Reset" onClick={handleReset} style={{
            flexDirection: "row",
            display: 'flex',
            width: '120px',
            padding: '14px 49px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            borderRadius: '10px',
            background: '#FFF',
            color: '#357EFF',
            border: '2px solid #357EFF',
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '24px'
          }} />

          <Button className='save' type="submit" label="Save" onClick={handleSubmit} style={{
            display: 'flex',
            width: '120px',
            marginLeft: "10px",
            padding: '14px 49px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            borderRadius: '10px',
            background: '#357EFF',
            color: '#FFF',
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '24px'
          }} />
        </div>
      </form>

    </Layer>


  );
});


export default FlightEditForm;
